/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { manufacturerOutstandingBalanceGrid } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getManufacturerOutstandingBalReport,
  setManufacturerOutstandingBalReport,
  setMfgOutstandingBalReportDataForExportAll,
  getMfgOutstandingBalReportDataForExportAll,
  setPaginationIndex,
} from '../Store/Actions';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

const DisManufacturerOutstansdingBal = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef();

  // use Selector function
  const {
    isLoading,
    exportAllData,

    displayObj: {
      rebateProgramName,
      allRebateProgram,
      quarterValue,
      manufacturerSelected,
      searchResult,
      // headerSearchResult,
      countValue,
    },
    headerSearchResult,
  } = useSelector(
    (state) => state?.sharedState?.ManufacturerOutstandingBalanceReducer
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [columnApi, setColumnApi] = React.useState(null);

  const [searchResultList, setSearchResultList] = React.useState(searchResult);
  const [count, setCount] = React.useState(countValue);
  const [resultHeader, setResultHeader] = React.useState(headerSearchResult);
  const [paginationArray, setPaginationArray] = React.useState([
    // ...Array(headerSearchResult?.length).keys(),
  ]);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [exportAllClicked, setExportAllClicked] = useState(false);

  // To pin the total row

  const [displayedRows, setDisplayedRows] = React.useState(
    searchResultList ?? []
  );
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  /*
       this function handle the vlue like text in input box
    */

  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }
    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }
    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      // setTimeout(() => {
      await Promise.resolve();
      value < 1
        ? dispatch(setPaginationIndex(1))
        : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const sum = (property) => {
  const displayedRows = filterApply ? filteredRows : searchResultList;
  if (property === 'checkLogNum') {
    const data = displayedRows.length;
    return `${data} Checks`;
  }
  const data = displayedRows?.reduce((acc, obj) => {
    return acc + (obj[property] ? parseFloat(obj[property]) : 0);
  }, 0);
  return data ? parseFloat(data.toFixed(4)) : 0.0; // 4 decimals for units, or .toFixed(2) for dollar values if needed
};

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        manufacturer: 'Totals',
        totReimbursedUnits: sum('totReimbursedUnits').toFixed(4),
        paidUnits: sum('paidUnits').toFixed(4),
        unpaidUnits: sum('unpaidUnits').toFixed(4),
        disputedUnits: sum('disputedUnits').toFixed(4),
        totDollerInvoiced: sum('totDollerInvoiced'),
        totDollerPaid: sum('totDollerPaid'),
        totDollerOutstanding: sum('totDollerOutstanding'),
        totDollerDisputed: sum('totDollerDisputed'),
      });
    }
    return result;
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [searchResultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // API Call fror Details Screen
  React.useEffect(() => {
    if (resultHeader?.[count - 1]?.rebateProgramCd) {
      setSearchResultList([]);
      dispatch(setManufacturerOutstandingBalReport([]));
      dispatch(
        getManufacturerOutstandingBalReport({
          qtr: quarterValue,
          mfgId:
            manufacturerSelected == 'ALL'
              ? [manufacturerSelected]
              : manufacturerSelected,
          aiAll: manufacturerSelected == 'ALL' ? 1 : 0,
          rebateProgramCd: resultHeader?.[count - 1]?.rebateProgramCd,
        })
      );
    }
  }, [count]);

  React.useEffect(() => {
    if (headerSearchResult?.length) {
      setPaginationArray([...Array(headerSearchResult?.length).keys()]);
      setResultHeader(headerSearchResult);
    }
  }, [headerSearchResult]);

  React.useEffect(() => {
    setSearchResultList([]);
    const updatedSearchResult = searchResult || [];
    setSearchResultList(updatedSearchResult);
  }, [searchResult]);

  // pdf header
  let firstInfo = '';
  const secondInfo = `Rebate Program:${
    allRebateProgram
      ? resultHeader?.[count - 1]?.rebateProgramName || 'ALL'
      : `${rebateProgramName?.rebateProgramCd} - ${rebateProgramName?.shortDescr}` ||
        'ALL'
  }`;

  firstInfo = `Quarter:${quarterValue}`;

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    dispatch(setMfgOutstandingBalReportDataForExportAll([], 'noData'));
    setExportAllClicked(true);
    dispatch(
      getMfgOutstandingBalReportDataForExportAll({
        qtr: quarterValue,
        mfgId:
          manufacturerSelected == 'ALL'
            ? [manufacturerSelected]
            : manufacturerSelected,
        aiAll: manufacturerSelected == 'ALL' ? 1 : 0,
        rebatePrograms: resultHeader,
      })
    );
  };

  const addPinnedRowData = () => {
    const exportAllDataObj = {};
    for (const key in exportAllData) {
      const data = exportAllData[key];
      const pinnedRow = {
        isBottomRow: true,
        manufacturer: 'Total: ',
        ndcCount: 0,
        totReimbursedUnits: 0,
        paidUnits: 0,
        unpaidUnits: 0.0,
        disputedUnits: 0.0,
        totDollerInvoiced: 0.0,
        totDollerPaid: 0.0,
        totDollerOutstanding: 0.0,
        totDollerDisputed: 0.0,
        bold: true,
      };
      for (let i = 0; i < data.length; i += 1) {
        pinnedRow.ndcCount += data[i].ndcCount;
        pinnedRow.totReimbursedUnits += data[i].totReimbursedUnits;
        pinnedRow.paidUnits += data[i].paidUnits;
        pinnedRow.unpaidUnits += data[i].unpaidUnits;
        pinnedRow.disputedUnits += data[i].disputedUnits;
        pinnedRow.totDollerInvoiced += data[i].totDollerInvoiced;
        pinnedRow.totDollerPaid += data[i].totDollerPaid;
        pinnedRow.totDollerOutstanding += data[i].totDollerOutstanding;
        pinnedRow.totDollerDisputed += data[i].totDollerDisputed;
      }
      data.push(pinnedRow);
      exportAllDataObj[key] = data;
    }

    return exportAllDataObj;
  };
  React.useEffect(() => {
    if (
      exportAllClicked &&
      Object.keys(exportAllData).length === resultHeader.length
    ) {
      const header = {
        fileName: exportFileName
          ? exportFileName
          : 'Manufacturer Outstanding Balance Report',
        reportName: 'Manufacturer Outstanding Balance Report',
      };
      const paginationArr = resultHeader.map((item) => item.rebateProgramCd);
      const allData = addPinnedRowData(exportAllData);
      const widths = manufacturerOutstandingBalanceGrid.map((item, index) =>
        index === 0 ? 200 : '*'
      );
      for (const key in allData) {
        allData[key] = allData[key].map((item) => {
          return {
            ...item,
            totDollerDisputed: item.totDollerDisputed
              ? item.totDollerDisputed
              : '0.00',
            totDollerOutstanding: item.totDollerOutstanding
              ? item.totDollerOutstanding
              : '0.00',
            totDollerPaid: item.totDollerPaid ? item.totDollerPaid : '0.00',
            totDollerInvoiced: item.totDollerInvoiced
              ? item.totDollerInvoiced
              : '0.00',
            totReimbursedUnits: item.totReimbursedUnits
              ? item.totReimbursedUnits.toFixed(4)
              : '0.0000',
            paidUnits: item.paidUnits ? item.paidUnits.toFixed(4) : '0.0000',
            disputedUnits: item.disputedUnits
              ? item.disputedUnits.toFixed(4)
              : '0.0000',
            unpaidUnits: item.unpaidUnits
              ? item.unpaidUnits.toFixed(4)
              : '0.0000',
          };
        });
      }
      setExportAllClicked(false);
      exportAllPDF(
        header,
        allData,
        columnApi,
        userDefaults,
        {
          pageSize: {
            width: 1250,
            height: 700,
          },
          info: {
            fourthInfo: `Quarter: ${quarterValue}`,
          },
        },
        paginationArr,
        widths,
        logInUser
      );
    }
  }, [exportAllData]);
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Display Manufacturing Outstanding Balance"
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row mb-5">
              <div className="col-12">
                <div className="float-right">
                  <PaginationBox
                    array={paginationArray}
                    count={count}
                    handleClick={handleClick}
                    handleBlur={handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program "
                          id="Rebate Program "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            allRebateProgram
                              ? resultHeader?.[count - 1]?.rebateProgramName ||
                                'ALL'
                              : `${rebateProgramName?.rebateProgramCd} - ${rebateProgramName?.shortDescr}` ||
                                'ALL'
                          }
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Quarter "
                          id="Quarter "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={quarterValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix">
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              ref={gridRef}
              gridCall={onGridReady}
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={
                fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
              }
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              countValue={count}
              rowData={searchResultList?.map((item) => {
                return {
                  ...item,
                  totDollerDisputed: item.totDollerDisputed
                    ? item.totDollerDisputed
                    : '0.00',
                  totDollerOutstanding: item.totDollerOutstanding
                    ? item.totDollerOutstanding
                    : '0.00',
                  totDollerPaid: item.totDollerPaid
                    ? item.totDollerPaid
                    : '0.00',
                  totDollerInvoiced: item.totDollerInvoiced
                    ? item.totDollerInvoiced
                    : '0.00',
                  totReimbursedUnits: item.totReimbursedUnits
                    ? item.totReimbursedUnits.toFixed(4)
                    : '0.0000',
                  paidUnits: item.paidUnits
                    ? item.paidUnits.toFixed(4)
                    : '0.0000',
                  disputedUnits: item.disputedUnits
                    ? item.disputedUnits.toFixed(4)
                    : '0.0000',
                  unpaidUnits: item.unpaidUnits
                    ? item.unpaidUnits.toFixed(4)
                    : '0.0000',
                };
              })}
              columnDefs={manufacturerOutstandingBalanceGrid}
              exportFile
              animateRows
              sideBar={false}
              reportName="Manufacturer Outstanding Balance Report"
              fileName="ManufacturerOutstandingBalance"
              isScrollOn
              // defaultColWidth={280}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              hideColumnsInPdf
              info={{
                firstInfo,
                secondInfo,
              }}
              onFilterData={onFilterChanged}
              pinnedBottomRowData={pinnedBottomRowData}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              exportAllTpPDF={resultHeader?.length > 1 ? exportAllTpPDF : null}
              getFilterApply={getFilterApply}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisManufacturerOutstansdingBal;
